module.exports = __webpack_public_path__ + "assets/img/logo-reg.28d97a3a.png";